module.exports = "../images/icons/wire-transfer.svg";